<df-funnels-list-sub-header></df-funnels-list-sub-header>
<router-outlet></router-outlet>
<df-button-new (click)="createNewFunnel()"></df-button-new>
